import { Component } from 'react';
import { connect } from 'react-redux';
import isEqual from 'lodash-es/isEqual';
import autoBind from 'react-autobind';

import Breadcrumbs from '../../Breadcrumbs';
import { setActiveHref } from '../../../actions/leftBar.actions';
import { countryList } from '../../../data/filing';
import withComponentName from '../../../decorators/withComponentName';

class BreadCrumbs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbs: [],
    };

    autoBind(this);
  }

  componentDidMount() {
    const { setActiveHref: propsSetActiveHref } = this.props;
    propsSetActiveHref('');
    this.setBradeCrumbs();
  }

  componentDidUpdate(prevProps) {
    const { match, isAll } = this.props;
    if (!isEqual(prevProps.match.params, match.params) || prevProps.isAll !== isAll) {
      this.setBradeCrumbs();
    }
  }

  getCountryName(code) {
    const foundCountry = countryList.find((f) => f.ticker === code) || { };
    return foundCountry.name || '';
  }

  setBradeCrumbs() {
    const { setActiveDirectories, match, isAll } = this.props;
    const breadcrumbs = [
      {
        name: 'Directory Home',
        path: 'news/directory',
        onClick: setActiveDirectories,
      },
      {
        name: 'Filings',
        path: 'directory/filings',
        onClick: setActiveDirectories,
      },
    ];

    const { countryCode, providerCode } = match.params || {};
    const foundCountry = countryList.find((f) => f.ticker === countryCode) || { };
    if (countryCode) {
      breadcrumbs.push({
        id: 'countryCode',
        name: foundCountry.name,
        path: `directory/filings/${countryCode}`,
      });

      if (providerCode) {
        const foundSource = foundCountry.sources.find((f) => f.ticker === providerCode) || { };
        breadcrumbs.push({
          id: 'providerCode',
          name: foundSource.name,
          path: `directory/filings/${countryCode}/${providerCode}`,
        });

        if (isAll) {
          breadcrumbs.push({
            id: 'all',
            name: 'All Filings',
            path: `directory/filings/${countryCode}/${providerCode}/all`,
          });
        }
      }
    }

    this.setState({
      breadcrumbs,
    });
  }

  render() {
    const { breadcrumbs } = this.state;
    return (
      <Breadcrumbs items={breadcrumbs} base="" />
    );
  }
}

const mapToDispatchProps = (dispatch) => ({
  setActiveHref: (href) => dispatch(setActiveHref(href)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...dispatchProps,
  setActiveDirectories: () => dispatchProps.setActiveHref('/directory/filings'),
});

export default withComponentName(
  connect(null, mapToDispatchProps, mergeProps)(BreadCrumbs),
);
